import { gql } from '@apollo/client';
import { SERVICE_PROVIDER } from '../fragments';

export const ADMIN_SERVICE_PROVIDERS = gql`
  query AdminServiceProviders($input: FilterArgs) {
    adminServiceProviders(input: $input) {
      ...serviceProvider
      interventions {
        id
        name
      }
      users {
        id
      }
      programmes {
        id
      }
      institutions {
        id
      }
      funder {
        id
      }
    }
  }
  ${SERVICE_PROVIDER}
`;
